import {Fill, Icon, Stroke, Style, Text} from 'ol/style';
import {Circle as CircleStyle} from 'ol/style';

// Dot for the overlay.
const global_VectorOverlayDot = new CircleStyle({
    radius: 5,
    fill: null,
    stroke: new Stroke({color: 'red', width: 1})
  });

export const AutopilotTrackStyle =
  new Style({
    stroke: new Stroke({
      color: 'green',
      width: 4
    })
  });

export const AutopilotArrowStyle =
new Style({
  stroke: new Stroke({
    color: 'yellow',
    width: 6
  })
});

export const AutopilotTargetDotStyle = new Style({
  image: new CircleStyle({
    radius: 8,
    fill: new Fill({ color: 'yellow' }),
    stroke: new Stroke({color: 'red', width: 2})
  })
});

export const AutopilotDebugArrowStyle =
new Style({
  stroke: new Stroke({
    color: 'brown',
    width: 6
  })
});

export const AutopilotDebugTargetDotStyle = new Style({
  image: new CircleStyle({
    radius: 8,
    fill: new Fill({ color: 'brown' }),
    stroke: new Stroke({color: 'blue', width: 2})
  })
});


export const VectorOverlayStyles = {
    'Point': new Style({
      image: global_VectorOverlayDot
    }),
    'LineString': new Style({
      stroke: new Stroke({
        color: 'black',
        width: 2
      })
    }),
    'MultiLineString': new Style({
      stroke: new Stroke({
        color: 'green',
        width: 1
      })
    }),
    'MultiPoint': new Style({
      image: global_VectorOverlayDot
    }),
    'MultiPolygon': new Style({
      stroke: new Stroke({
        color: 'yellow',
        width: 1
      }),
      fill: new Fill({
        color: 'rgba(255, 255, 0, 0.1)'
      })
    }),
    'Polygon': new Style({
      stroke: new Stroke({
        color: 'blue',
        lineDash: [4],
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    }),
    'GeometryCollection': new Style({
      stroke: new Stroke({
        color: 'magenta',
        width: 2
      }),
      fill: new Fill({
        color: 'magenta'
      }),
      image: new CircleStyle({
        radius: 10,
        fill: null,
        stroke: new Stroke({
          color: 'magenta'
        })
      })
    }),
    'Circle': new Style({
      stroke: new Stroke({
        color: 'red',
        width: 2
      }),
      fill: new Fill({
        color: 'rgba(255,0,0,0.2)'
      })
    })
  };

export const VectorOverlayStylesFollowedVessel = {
    'Point': new Style({
      image: global_VectorOverlayDot
    }),
    'LineString': [
      new Style({
        stroke: new Stroke({
          color: 'white',
          width: 5
        })
      }),
      new Style({
        stroke: new Stroke({
          color: 'red',
          width: 1.5
        })
      })
    ]
    ,
    'MultiLineString': new Style({
      stroke: new Stroke({
        color: 'green',
        width: 1
      })
    }),
    'MultiPoint': new Style({
      image: global_VectorOverlayDot
    }),
    'MultiPolygon': new Style({
      stroke: new Stroke({
        color: 'yellow',
        width: 1
      }),
      fill: new Fill({
        color: 'rgba(255, 255, 0, 0.1)'
      })
    }),
    'Polygon': new Style({
      stroke: new Stroke({
        color: 'blue',
        lineDash: [4],
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    }),
    'GeometryCollection': new Style({
      stroke: new Stroke({
        color: 'magenta',
        width: 2
      }),
      fill: new Fill({
        color: 'magenta'
      }),
      image: new CircleStyle({
        radius: 10,
        fill: null,
        stroke: new Stroke({
          color: 'magenta'
        })
      })
    }),
    'Circle': new Style({
      stroke: new Stroke({
        color: 'red',
        width: 2
      }),
      fill: new Fill({
        color: 'rgba(255,0,0,0.2)'
      })
    })
  };

  export const VectorOverlayStylesFollowedTrack = {
    'Point': new Style({
      image: global_VectorOverlayDot
    }),
    'LineString': [
      new Style({
        stroke: new Stroke({
          color: 'black',
          width: 3
        })
      }),
      new Style({
        stroke: new Stroke({
          color: 'red',
          width: 1.2
        })
      })
    ]
    ,
    'MultiLineString': new Style({
      stroke: new Stroke({
        color: 'green',
        width: 1
      })
    }),
    'MultiPoint': new Style({
      image: global_VectorOverlayDot
    }),
    'MultiPolygon': new Style({
      stroke: new Stroke({
        color: 'yellow',
        width: 1
      }),
      fill: new Fill({
        color: 'rgba(255, 255, 0, 0.1)'
      })
    }),
    'Polygon': new Style({
      stroke: new Stroke({
        color: 'blue',
        lineDash: [4],
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    }),
    'GeometryCollection': new Style({
      stroke: new Stroke({
        color: 'magenta',
        width: 2
      }),
      fill: new Fill({
        color: 'magenta'
      }),
      image: new CircleStyle({
        radius: 10,
        fill: null,
        stroke: new Stroke({
          color: 'magenta'
        })
      })
    }),
    'Circle': new Style({
      stroke: new Stroke({
        color: 'red',
        width: 2
      }),
      fill: new Fill({
        color: 'rgba(255,0,0,0.2)'
      })
    })
  };

  export const VectorOverlayStylesGreen = {
    'Point': new Style({
      image: global_VectorOverlayDot
    }),
    'LineString': new Style({
      stroke: new Stroke({
        color: 'green',
        width: 2
      })
    }),
    'MultiLineString': new Style({
      stroke: new Stroke({
        color: 'green',
        width: 1
      })
    }),
    'MultiPoint': new Style({
      image: global_VectorOverlayDot
    }),
    'MultiPolygon': new Style({
      stroke: new Stroke({
        color: 'yellow',
        width: 1
      }),
      fill: new Fill({
        color: 'rgba(255, 255, 0, 0.1)'
      })
    }),
    'Polygon': new Style({
      stroke: new Stroke({
        color: 'blue',
        lineDash: [4],
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    }),
    'GeometryCollection': new Style({
      stroke: new Stroke({
        color: 'magenta',
        width: 2
      }),
      fill: new Fill({
        color: 'magenta'
      }),
      image: new CircleStyle({
        radius: 10,
        fill: null,
        stroke: new Stroke({
          color: 'magenta'
        })
      })
    }),
    'Circle': new Style({
      stroke: new Stroke({
        color: 'red',
        width: 2
      }),
      fill: new Fill({
        color: 'rgba(255,0,0,0.2)'
      })
    })
  };

  export const VectorOverlayStylesNone = [];

export const CraneMarkStyle =
  new Style({
    stroke: new Stroke({
      color: 'black',
      width: 2
    })
  });

export function CreateStrokeStyle(strokeColor)
{
  const r = [
    new Style({
      stroke: new Stroke({
        color: strokeColor,
        width: 5
      })
    }),
    new Style({
      stroke: new Stroke({
        color: 'yellow',
        width: 1.5
      })
    })
  ];
  return r;
}
